import { inject, Injectable } from '@angular/core';
import { AccountResource } from '@mkp/account/data-access';
import { UUID } from '@mkp/shared/models';
import { Vacancy } from '@mkp/vacancy/models';
import { forkJoin, Observable } from 'rxjs';
import { map, mergeMap, shareReplay } from 'rxjs/operators';
import { VacancyService } from './services/vacancy.service';

@Injectable({
  providedIn: 'root',
})
export class VacancyDetailResource {
  private readonly vacancyApi = inject(VacancyService);
  private readonly accountResource = inject(AccountResource);

  getVacancy(vacancyId: UUID): Observable<Vacancy> {
    const vacancy$ = this.vacancyApi
      .read(vacancyId)
      .pipe(shareReplay({ bufferSize: 1, refCount: true }));
    const accountDto$ = vacancy$.pipe(
      mergeMap(({ accountId }) => this.accountResource.getById(accountId))
    );

    return forkJoin([vacancy$, accountDto$]).pipe(
      map(([vacancy, accountDto]) => ({
        ...vacancy,
        companyName: accountDto._embedded.legalEntity.name,
      }))
    );
  }

  deleteVacancy(vacancyId: UUID): Observable<string> {
    return this.vacancyApi.delete(vacancyId).pipe(map(() => vacancyId));
  }
}
